interface Props {
  name?: string | null;
  email?: string;
  hue?: number | null;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  className?: string;
}

const sizeClasses = {
  xs: "w-6 h-6 text-[0.6rem]",
  sm: "w-8 h-8 text-xs",
  md: "w-10 h-10 text-sm",
  lg: "w-14 h-14 text-base",
  xl: "w-20 h-20 text-2xl",
};

export function Avatar({ name, email, hue, size = "md", className = "" }: Props) {
  const label = (name ?? email ?? "?").trim();
  const initial = label.charAt(0).toUpperCase();
  const stableHue = hue ?? hueFromString(email ?? name ?? "?");
  const bg = `linear-gradient(135deg, hsl(${stableHue}, 60%, 75%), hsl(${(stableHue + 18) % 360}, 55%, 55%))`;

  return (
    <div
      className={[
        sizeClasses[size],
        "rounded-full flex items-center justify-center text-white font-serif shrink-0",
        "shadow-[0_2px_6px_rgba(61,43,61,0.15)]",
        "ring-2 ring-white",
        className,
      ].join(" ")}
      style={{ backgroundImage: bg }}
      title={label}
    >
      {initial}
    </div>
  );
}

function hueFromString(s: string): number {
  let h = 0;
  for (const ch of s) h = (h * 31 + ch.charCodeAt(0)) & 0xffff;
  return h % 60 + 320 - 360 * Math.floor((h % 60 + 320) / 360);
}
